import { Box, Button, Stack, TextField, Typography } from "@mui/material";

/** Same text as EssayMarkingService::STANDARD_GUIDELINE (used when a writing task has none). */
export const STANDARD_WRITING_GUIDELINE = `Writing task — marked on four criteria:
• Content & ideas (40%): engaging, relevant, original response to the chosen prompt; ideas developed rather than listed.
• Structure & organisation (20%): clear opening, development and ending; paragraphs; controlled pace; effective final line.
• Language & style (25%): precise vocabulary, imagery used with restraint, varied sentence openings and lengths, consistent voice and tense.
• Technical accuracy (15%): spelling, punctuation (including speech), grammar.
Band guide: 85%+ exceptional – vivid, controlled, ambitious and accurate; 65–84% strong – engaging and mostly accurate; 45–64% competent – clear but predictable or uneven; below 45% – underdeveloped, limited control.`;

const plain = (html) => String(html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();

/** A marking scheme pasted where a model answer belongs (criteria, weights, bands) — mirrors the server check. */
export function looksLikeMarkingScheme(html) {
  const t = plain(html).toLowerCase();
  if (t.length < 40) return false;
  const hits = t.match(/content\s*(&|and)\s*ideas|structure\s*(&|and)\s*organis|language\s*(&|and)\s*style|technical accuracy|band guide|up to \d+\s*%|\d+\s*%\+?\s*[–-]\s*\p{L}|marking (scheme|guide|criteria)|mark scheme|total available|awards? \d+ marks?|^\s*\d+\s*marks?\s*:|level \d+\s*\(\d+\s*marks?\)|\d+\s*marks?\s*[•:]/gmu);
  return (hits || []).length >= 2;
}

/**
 * Essay / writing task: HOW marks are awarded. The AI essay marker scores the student's writing
 * against this, criterion by criterion; model answers are only examples and are never matched.
 */
export default function MarkingGuidelineField({ value, onChange, modelAnswer, onModelAnswerChange }) {
  const schemeInModel = !value && looksLikeMarkingScheme(modelAnswer);
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600, color: "#444" }}>
        Marking guideline
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
        How marks are awarded: criteria with their weight (%), and the bands. The AI marks the student's writing against
        this. Leave empty to use the standard 11+ writing guideline.
      </Typography>
      <TextField
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        multiline
        minRows={4}
        fullWidth
        size="small"
        placeholder={STANDARD_WRITING_GUIDELINE}
      />
      <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap" useFlexGap>
        {!value ? (
          <Button size="small" variant="outlined" onClick={() => onChange(STANDARD_WRITING_GUIDELINE)} sx={{ textTransform: "none" }}>
            Use the standard 11+ writing guideline
          </Button>
        ) : null}
        {schemeInModel ? (
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              onChange(plain(modelAnswer).replace(/\s*•\s*/g, "\n• ").trim());
              onModelAnswerChange?.("");
            }}
            sx={{ textTransform: "none" }}
          >
            The model answer below is a marking scheme — move it here
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
}
